module.exports = __webpack_public_path__ + "static/przestronne-tarasy-8bbcf3cfc503634a4e6856370b613706.jpg";